import cloneDeep from "lodash/cloneDeep";
import type { NestedStyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

interface MergeStylesPreservingArgs {
  current?: NestedStyleValue;
  defaults?: NestedStyleValue;
  preserveKeys?: string[];
}

export const mergeStylesPreserving = ({
  current,
  defaults,
  preserveKeys = [],
}: MergeStylesPreservingArgs): NestedStyleValue => {
  if (!current && !defaults) {
    return {};
  }

  const base: NestedStyleValue = current
    ? cloneDeep(current)
    : cloneDeep(defaults ?? {});

  if (!defaults) {
    return base;
  }

  Object.entries(defaults).forEach(([key, defaultValue]) => {
    if (preserveKeys.includes(key)) return;
    base[key] = cloneDeep(defaultValue);
  });

  return base;
};
